import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { userSessionSlice } from './UserSessionSlice';
import { chatSlice } from './ChatRedux';
import { employeeslice } from './EmployeeRedux';
import { networkslice } from './NetworkRedux';
import { dealSlice } from './DealRedux';
import { newsfeedslice } from './NewsFeedRedux';
import { mediakitslice } from './MediakitRedux';
import { certificationslice } from './CertificationRedux';
import { collaborationSlice } from './CollaborationRedux';
import { resourceSlice } from './ResourceRedux';
import { departmentslice } from './DepartmentRedux';
import { recogniseSlice } from './RecogniseRedux';
import { recogniseApi } from '../containers/Recognition/Queries/RecogniseQuery';
import { meetingSlice } from './TrainingRedux';
import { viewResourceSlice } from './MyResourceRedux';
import { licenseSlice } from './licenseRedux';
import { newnetworkslice } from './NewNetworkRedux';
import { presenceSlice } from './PresenceRedux';
import { callSlice } from './CallsRedux';
import audioPlayerReducer from './AudioPlayerSlice';

export const store = configureStore({
	reducer : {
		mysession                  : userSessionSlice.reducer,
		mychat                  	  : chatSlice.reducer,
		myemployee                 : employeeslice.reducer,
		mynetwork                  : networkslice.reducer,
		mynewnetwork               : newnetworkslice.reducer,
		mydeal                     : dealSlice.reducer,
		myDepartment               : departmentslice.reducer,
		mynewsFeed                 : newsfeedslice.reducer,
		mymediakit                	: mediakitslice.reducer,
		mycollaboration            : collaborationSlice.reducer,
		myresource                 : resourceSlice.reducer,
		mycertification            : certificationslice.reducer,
		myrecognise                : recogniseSlice.reducer,
		[recogniseApi.reducerPath] : recogniseApi.reducer,
		mymeetings                 : meetingSlice.reducer,
		viewmyresource             : viewResourceSlice.reducer,
		mylicense  	               : licenseSlice.reducer,
		mypresence                 : presenceSlice.reducer,
		call                       : callSlice.reducer,
		audioPlayer                : audioPlayerReducer
	},
	middleware : (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck : false
		}).concat([ recogniseApi.middleware ]),
	devTools : true
});

setupListeners(store.dispatch);
